/* Copyright (c) 2022 MOCA Systems, Inc.	All rights reserved. */

import * as strings from '@touchplan/strings';
import { TimeScale } from './TimeScale';

export class TimeScaleUtils {
	private static labelToEnum = {
		[strings.TIME_SCALE_DAY]: TimeScale.Day,
		[strings.TIME_SCALE_WEEK]: TimeScale.Week,
		[strings.TIME_SCALE_QUARTER]: TimeScale.Quarter,
	};

	private static labelToSortOrder = {
		[strings.TIME_SCALE_DAY]: 1,
		[strings.TIME_SCALE_WEEK]: 2,
		[strings.TIME_SCALE_QUARTER]: 3,
	};

	public static labelToEnumMap = TimeScaleUtils.getLabelToEnumDataMap();

	private static getLabelToEnumDataMap() {
		return new Map(Object.entries(TimeScaleUtils.labelToEnum));
	}

	public static getSortOrderForLabel(label: string) {
		return TimeScaleUtils.labelToSortOrder[label] as number;
	}
}
